export const MY_COMPANY_PROJECT_ID = "my-company";

export function filterVisibleProjects(projects, customersAndProjectsEnabled, myCompanyEnabled) {
  return projects.filter(project =>
    (project.id || project._id) === MY_COMPANY_PROJECT_ID
      ? myCompanyEnabled === true
      : customersAndProjectsEnabled === true
  );
}
